import { io } from "socket.io-client";

// const SOCKET_URL = "http://localhost:8000"; // Change to your backend URL
const SOCKET_URL = "https://thegradstory.co.uk"; // Change to your backend URL

export const socket = io(SOCKET_URL, {
    transports: ["websocket"], // Ensures stable connection
});
